import { render } from "./OrganizationLogoUpload.vue?vue&type=template&id=40e73573&scoped=true"
import script from "./OrganizationLogoUpload.vue?vue&type=script&lang=js"
export * from "./OrganizationLogoUpload.vue?vue&type=script&lang=js"

import "./OrganizationLogoUpload.vue?vue&type=style&index=0&id=40e73573&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e73573"]])

export default __exports__